import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PreCancel from "./component";
import { getPlans } from "../plan/actions";
import { updateUserPlan, addGuestUsersBulk } from "./actions";
import { accountCancellation, getOrderDataByUserId, getBilling, getGuestUser } from "../settings/actions";

const mapStateToProps = ({ funnelStep }) => ({ funnelStep });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPlansConnect: getPlans,
      updateUserPlanConnect: updateUserPlan,
      accountCancellationConnect: accountCancellation,
      getOrderDataByUserIdConnect: getOrderDataByUserId,
      getBillingConnect: getBilling,
      addGuestUsersBulkConnect: addGuestUsersBulk,
      getGuestUserConnect: getGuestUser,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(PreCancel);
